<template>
  <v-col cols="12" class="px-0">
    <field-group
      v-if="isCreate"
      item-text="name"
      item-value="code"
      :value="srs"
      filled
      :items="srsList"
      required
      label="Hệ toạ độ"
      no-label
      typeInput="v-autocomplete"
      @input="$emit('update:srs', $event)"
    ></field-group>
    <field-group
      v-if="isCreate"
      v-model="form.file"
      :error-messages="errors.file"
      typeInput="field-file-input"
      :rules="fileRules"
      accept=".zip"
      title="Tải Shapefile"
    ></field-group>
  </v-col>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
    errors: { type: Object, default: () => ({}) },
    isCreate: Boolean,
    srs: { default: null },
    srsList: { type: Array, default: () => [] },
  },
  data: () => ({
    fileRules: [(v) => !!v || 'File không thể bỏ trống'],
  }),
  computed: {
    form() {
      return this.value
    },
  },
}
</script>
